/**
 * View / edit drawer (/admin/feature-flags/:flagId) over the feature flags list.
 */
export const FeatureFlagDrawer = () => null;
